const SEO = [
	{
		page: "home",
		description:
			"I am Prathiba Ramesh, a passionate and results-driven Software Engineer with over 5 years of experience and a master's degree in Computer Science. My journey in technology has been defined by a relentless pursuit of excellence and a commitment to continuous learning. Over the years, I have developed expertise in software development, system architecture, and performance optimization. I am proficient in a variety of programming languages and have a proven track record of designing and implementing scalable, efficient, and maintainable software systems.",
		keywords: [""],
	},

	{
		page: "about",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. My most recent experience as a Software Engineer Intern at KQED Public Media involved leveraging Tableau and MongoDB for data-rich reports and dashboards, facilitated seamless data migration, and established a dynamic pipeline with Python. I automated report generation, enhanced data security, and integrated systems using HTML, CSS, and Python Flask. Throughout my Graduate program, I have developed full stack web applications using JavaScript, involving Node and ReactJS. Before this, I was a Software Engineer at Tata Consultancy Services where I worked on various projects involving C# and .Net Frameworks. ",
		keywords: [""],
	},

	{
		page: "articles",
		description:
			"Experience",
		keywords: [""],
	},

	{
		page: "projects",
		description:
			"I have garnered extensive experience working on multiple projects, each involving diverse technology stacks, over the course of my career. This varied exposure has equipped me with a robust skill set and a comprehensive understanding of different technologies, making me well-equipped to tackle multifaceted challenges in the field.",
		keywords: [""],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: [""],
	},
];

export default SEO;